"use client";

import { storyblokEditable } from "@storyblok/react/rsc";
import { renderRichText } from "@storyblok/react";
import type { PressReleaseStoryblok } from "@/component-types-sb";

import { Subline } from "@/components/typography/Subline";
import { Headline } from "@/components/typography/Headline";
import { RichText } from "@/components/typography/RichText";
import { formatDate } from "@/lib/utils/date";
import { cn } from "@/lib/utils";

type PressReleaseProps = {
  blok: PressReleaseStoryblok;
};

const PressRelease = ({ blok }: PressReleaseProps) => {
  return (
    <div
      className="flex flex-col justify-between px-4 pt-8 pb-16 lg:pt-16 lg:pb-24 mx-auto max-w-screen-xl"
      {...storyblokEditable(blok)}
    >
      <article
        className={cn(
          "mx-auto w-full max-w-3xl format format-sm sm:format-base lg:format-lg format-blue text-black-100"
        )}
      >
        <header className="mb-4 lg:mb-6 not-format">
          <Subline>
            <time dateTime={blok.date}>
              {blok.date && formatDate(new Date(blok.date))}
            </time>
          </Subline>
          <Headline as="h1" size="huge" className="mb-4 lg:mb-6">
            {blok.title}
          </Headline>
        </header>

        <p className="text-lead mb-8">{blok.subtitle}</p>
        <p className="text-lead mb-8">{blok.except}</p>

        <RichText html={renderRichText(blok.text)} />
      </article>
    </div>
  );
};

export default PressRelease;
